module.exports = __webpack_public_path__ + "img/fronx-boostergreen.d3957e7d.png";